import axios, { AxiosError } from "axios";
import { MasterCompanyResponse } from "models/company/MasterCompany";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

interface OptionValue {
    value: string
    label: string
}

export default function WorkflowPerformanceViewModel() {

    const [fetchingCount, setFetchingCount] = useState(0)
    const [companyMaster, setCompanyMater] = useState<OptionValue[]>();
    const [selectedCompany, setSelectedCompany] = useState<OptionValue[]>([]);

    useEffect(() => {
        fetchCompanyMaster()
        // fetchWorkflowUsageRate() // the value maybe off a little bit when fetched
    }, []);

    const increaseFetchingCount = () => {
        setFetchingCount(prev => prev + 1);
    }

    const decreaseFetchingCount = () => {
        setFetchingCount(prev => prev > 0 ? prev - 1 : prev);
    }

    const fetchCompanyMaster = async () => {
        increaseFetchingCount()

        try {
            const response = await axios.get<MasterCompanyResponse>(
                '/v1/company_master',
                {
                    headers: {
                        Authorization:
                            'Bearer ' + localStorage.getItem('WF_APPLICATION')
                    }
                }
            );

            // console.log('company res', response)

            setCompanyMater(response.data.result_list.map((company) => ({
                value: company.sid,
                label: company.company_name,
            }))
            )
        } catch (e) {
            handleError(e)
        } finally {
            decreaseFetchingCount()
        }
    };

    const handleError = (error: any) => {
        if (!error) return;

        if (error instanceof AxiosError) {
            Swal.fire(
                'Error',
                error.response?.data.message || 'ไม่ทราบสาเหตุ'
            );
        } else if (error instanceof Error) {
            Swal.fire('Error', error.message);
        }
    }

    return {
        companyMaster,
        selectedCompany,


    }
}
